module.exports = __webpack_public_path__ + "img/1515739402.c79d00bb.jpg";